import { metricKeys } from '@pulse/metrics';
import { isEmpty } from 'lodash';
import useSetExport from '@components/export/useSetExport';
import { isAppModule } from '@utils/constants';
import { SPI_LABEL } from '../widgets/constants';
import { getMetricMetaByKey } from '@src/utils/metrics/metricHelpers';

const getSummaryExportHeader = (category, threshold) => {
  const { name, metrics } = category;
  const headers: any = [{ key: name, title: '' }];
  const SPIMetric = isAppModule
    ? metricKeys.AppServicePerformanceIndex
    : metricKeys.StreamingPerformanceIndex;
  const SPIText =
    SPIMetric === metricKeys.AppServicePerformanceIndex ? `${SPI_LABEL.APP}:` : `${SPI_LABEL.EI}:`;

  metrics.forEach((metric) => {
    const metricInfo = getMetricMetaByKey({ metricKey: metric });
    headers.push({
      key: metric,
      title:
        metric === SPIMetric && threshold
          ? `${SPIText} ${threshold?.kpiName}`
          : `${metricInfo.displayName}${metricInfo.unit ? ` (${metricInfo.unit})` : ''}`,
    });
  });

  return headers;
};

function useSetSummaryExport({ totals = {}, dodTotals = {}, currentKpi = {}, category }) {
  useSetExport({
    pageKey: 'trends',
    sectionKey: 'summary-panel',
    widgetKey: `summary-widget::${category.name}`,
    headers: getSummaryExportHeader(category, currentKpi),
    data: [{ ...totals, [category.name]: '' }],
    widgetInfo: {
      title: category.name,
    },
  });

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'summary-panel',
    widgetKey: `dod-summary-widget::${category.name}`,
    headers: getSummaryExportHeader(category, currentKpi),
    widgetInfo: {
      title: `Date Comparison: ${category.name}`,
    },
    data: !isEmpty(dodTotals) ? [{ ...dodTotals, [category.name]: '' }] : [],
  });
}

export default useSetSummaryExport;
